import { ClinicLocationsResponse } from '@chiroup/core/types/ClinicMapLocation.type';
import { useQuery } from 'react-query';
import clinicMapService from '../services/clinicMap.service';

const useClinicMapLocations = () => {
  const { data, isLoading, error, refetch, isFetched } = useQuery<ClinicLocationsResponse, Error>(
    ['clinic-map-locations'],
    () => clinicMapService.getLocations(),
    {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // Cache for 5 minutes
      retry: 2,
    }
  );

  return {
    locations: data?.locations || [],
    total: data?.total || 0,
    isLoading,
    error,
    refetch,
    isFetched,
  };
};

export default useClinicMapLocations;
